// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/announce.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * Announce構造体
 *
 * @generated from message entity.Announce
 */
export class Announce extends Message<Announce> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: entity.AnnounceMedia thumbnail_image = 4 [json_name = "thumbnail_image"];
   */
  thumbnailImage?: AnnounceMedia;

  /**
   * @generated from field: repeated entity.AnnounceMedia gallery_images = 5 [json_name = "gallery_images"];
   */
  galleryImages: AnnounceMedia[] = [];

  /**
   * @generated from field: repeated entity.AnnounceMedia videos = 6;
   */
  videos: AnnounceMedia[] = [];

  /**
   * @generated from field: repeated entity.AnnounceMedia content_media = 7 [json_name = "content_media"];
   */
  contentMedia: AnnounceMedia[] = [];

  /**
   * @generated from field: int32 display_priority = 8 [json_name = "display_priority"];
   */
  displayPriority = 0;

  /**
   * @generated from field: google.protobuf.Timestamp publish_date = 9 [json_name = "publish_date"];
   */
  publishDate?: Timestamp;

  /**
   * @generated from field: bool is_published = 10 [json_name = "is_published"];
   */
  isPublished = false;

  /**
   * @generated from field: string environment = 11;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 12 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 13 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 14;
   */
  version = "";

  constructor(data?: PartialMessage<Announce>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.Announce";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "thumbnail_image", jsonName: "thumbnail_image", kind: "message", T: AnnounceMedia },
    { no: 5, name: "gallery_images", jsonName: "gallery_images", kind: "message", T: AnnounceMedia, repeated: true },
    { no: 6, name: "videos", kind: "message", T: AnnounceMedia, repeated: true },
    { no: 7, name: "content_media", jsonName: "content_media", kind: "message", T: AnnounceMedia, repeated: true },
    { no: 8, name: "display_priority", jsonName: "display_priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "publish_date", jsonName: "publish_date", kind: "message", T: Timestamp },
    { no: 10, name: "is_published", jsonName: "is_published", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 13, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 14, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Announce {
    return new Announce().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Announce {
    return new Announce().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Announce {
    return new Announce().fromJsonString(jsonString, options);
  }

  static equals(a: Announce | PlainMessage<Announce> | undefined, b: Announce | PlainMessage<Announce> | undefined): boolean {
    return proto3.util.equals(Announce, a, b);
  }
}

/**
 *
 *
 * @generated from message entity.AnnounceMedia
 */
export class AnnounceMedia extends Message<AnnounceMedia> {
  /**
   * ファイル名
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * ファイルサイズ（バイト）
   *
   * @generated from field: int64 size = 2;
   */
  size = protoInt64.zero;

  /**
   * MIMEタイプ（image/jpeg, video/mp4など）
   *
   * @generated from field: string content_type = 3 [json_name = "content_type"];
   */
  contentType = "";

  /**
   * メディアタイプ（image/video）
   *
   * @generated from field: string media_type = 4 [json_name = "media_type"];
   */
  mediaType = "";

  /**
   * R2ストレージパス
   *
   * @generated from field: string storage_path = 5 [json_name = "storage_path"];
   */
  storagePath = "";

  /**
   * 表示順序
   *
   * @generated from field: int32 display_order = 6 [json_name = "display_order"];
   */
  displayOrder = 0;

  /**
   * キャプション（任意）
   *
   * @generated from field: string caption = 7;
   */
  caption = "";

  /**
   * キー名（Markdown内で参照するためのキー: ![alt](image:keyName) or ![alt](video:keyName)）
   *
   * @generated from field: string key_name = 8 [json_name = "key_name"];
   */
  keyName = "";

  constructor(data?: PartialMessage<AnnounceMedia>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.AnnounceMedia";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media_type", jsonName: "media_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "storage_path", jsonName: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "display_order", jsonName: "display_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "key_name", jsonName: "key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnnounceMedia {
    return new AnnounceMedia().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnnounceMedia {
    return new AnnounceMedia().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnnounceMedia {
    return new AnnounceMedia().fromJsonString(jsonString, options);
  }

  static equals(a: AnnounceMedia | PlainMessage<AnnounceMedia> | undefined, b: AnnounceMedia | PlainMessage<AnnounceMedia> | undefined): boolean {
    return proto3.util.equals(AnnounceMedia, a, b);
  }
}

